export default {"src":"/_next/static/media/notecard_playground.852df96c.svg","height":256,"width":362,"blurWidth":0,"blurHeight":0};